<template>
  <div
    class="journey-list-message"
    v-if="heading || text"
  >
    <div
      class="journey-list-message__header"
      @click="toggleOpen"
      :class="{ 'journey-list-message__header--open': isOpen }"
    >
      <span class="journey-list-message__circle">
        <svg class="journey-list-message__icon">
          <use :xlink:href="`#${info}`" />
        </svg>
      </span>
      <h3
        class="journey-list-message__heading"
        v-if="heading"
      >
        {{ heading }}
        <button class="journey-list-message__toggle">
          {{
            isOpen
              ? $t('common.actions.showLess')
              : $t('common.actions.readMore')
          }}
        </button>
      </h3>
    </div>
    <transition name="journey-list-message__content">
      <div
        v-if="isOpen"
        class="journey-list-message__text"
      >
        {{ text }}
        <slot name="extra" />
      </div>
    </transition>
  </div>
</template>

<script lang="ts">
  import { defineComponent, ref } from 'vue'
  import info from '@/assets/icons/info.svg'

  export default defineComponent({
    name: 'JourneyListMessage',
    props: {
      heading: {
        type: String,
        required: false,
        default: '',
      },
      text: {
        type: String,
        required: false,
        default: '',
      },
    },
    setup(props) {
      const isOpen = ref(false)

      const toggleOpen = () => {
        isOpen.value = !isOpen.value
      }

      return {
        isOpen,
        toggleOpen,
        info,
      }
    },
  })
</script>

<style lang="scss" scoped>
  .journey-list-message {
    margin: 1rem 0;
    background-color: $clr-tertiary-200;
    border-radius: $border-radius;
    overflow: hidden;
    color: $clr-text;

    &__header {
      padding: 1rem;
      display: flex;
      align-items: center;
      cursor: pointer;
      transition: background-color 0.2s ease;

      &:hover {
        background-color: rgba(0, 0, 0, 0.05);
      }
    }

    &__heading {
      @include title-medium;
      margin: 0 0.5rem;
      display: inline-block;
    }

    &__circle {
      width: 22px;
      height: 22px;
      background-color: $clr-tertiary;
      border-radius: 50%;
      align-self: flex-start;
      margin-top: 0.25rem;
    }

    &__icon {
      width: 24px;
      height: 24px;
      color: $clr-text;
    }

    &__toggle {
      @include body-medium;
      background: none;
      border: none;
      color: $clr-primary;
      cursor: pointer;
      display: inline-block;
      padding: 0;
    }

    &__text {
      padding: 1rem;
      font-size: 0.875rem;
      margin: 0;
    }

    &__content {
      &-enter-active,
      &-leave-active {
        transition: all 0.3s ease-out;
        overflow: hidden;
      }

      &-enter-from,
      &-leave-to {
        opacity: 0;
        max-height: 0;
        padding-top: 0;
        padding-bottom: 0;
      }

      &-enter-to,
      &-leave-from {
        opacity: 1;
        max-height: 200px;
      }
    }
  }
</style>
